/* Google Analytics 4 (gtag.js) — funil e-commerce da loja/portal MY. */
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export function initGA() {
  if (!GA_ID || window.__ihtpGaInit) return;
  window.__ihtpGaInit = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

export function gaEvent(name, params = {}) {
  try { if (window.gtag) window.gtag("event", name, { ...params, send_to: GA_ID }); } catch (_e) { /* noop */ }
}

/** Lê o client_id do cookie `_ga` (formato GA1.1.XXXX.YYYY → "XXXX.YYYY"). */
export function getGaClientId() {
  try {
    const m = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.([^;]+)/);
    return m ? m[1] : "";
  } catch (_e) { return ""; }
}

/**
 * Lê o session_id da visita a partir do cookie de sessão da propriedade de
 * destino `_ga_7D7Y2ENSW8` (nome FIXO — não derivar de
 * REACT_APP_GA4_MEASUREMENT_ID, que é outra propriedade).
 * Devolve só dígitos (session_id = início da visita em segundos Unix) ou "".
 *   GS1: "GS1.1.1699999999.3.…"                → 3.º segmento → "1699999999"
 *   GS2: "GS2.1.s1699999999$o3$g1$t…"          → token "s…" após "GS2.1." → "1699999999"
 */
export function getGaSessionId() {
  try {
    const m = document.cookie.match(/(?:^|;\s*)_ga_7D7Y2ENSW8=([^;]+)/);
    if (!m) return "";
    const raw = decodeURIComponent(m[1]);
    let sid = "";
    if (raw.startsWith("GS1.")) {
      sid = raw.split(".")[2] || "";
    } else if (raw.startsWith("GS2.1.")) {
      const tok = raw.slice("GS2.1.".length).split("$").find((t) => t.startsWith("s"));
      sid = tok ? tok.slice(1) : "";
    }
    return /^\d{1,20}$/.test(sid) ? sid : "";
  } catch (_e) { return ""; }
}

const num = (v) => Number(v) || 0;
const money = (v) => Math.round(num(v) * 100) / 100;

/** Converte produtos+packs do carrinho para o formato items[] do GA4. */
export function cartToGaItems(produtos = [], packs = []) {
  return [
    ...produtos.map((p) => ({
      item_id: String(p.ID_Produto ?? ""),
      item_name: p.Descricao || "Produto",
      item_brand: "IHTP",
      price: money(p.preco ?? p.PrecoUnitario),
      quantity: num(p.Quantidade) || 1,
    })),
    ...packs.map((p) => ({
      item_id: `pack-${p.ID_Pack ?? ""}`,
      item_name: p.Descricao || "Pack",
      item_brand: "IHTP",
      price: money(p.preco ?? p.PrecoUnitario),
      quantity: num(p.Quantidade) || 1,
    })),
  ];
}

/**
 * Monta items[] GA4 a partir do carrinho actual (nome + preço já ajustado ao
 * perfil do cliente), usando as quantidades efetivamente adicionadas.
 * @param {object} cartResp resposta de `myApi.cartGet()` (`{obj:{produtos}}` ou `{produtos}`).
 * @param {Array<{id_produto:(number|string), quantidade:number}>} added
 */
export function gaItemsFromCart(cartResp, added = []) {
  const data = cartResp?.obj || cartResp || {};
  const produtos = data.produtos || [];
  const byId = new Map(produtos.map((p) => [String(p.ID_Produto), p]));
  return added.map(({ id_produto, quantidade }) => {
    const line = byId.get(String(id_produto));
    return {
      item_id: String(id_produto),
      item_name: line?.Descricao || "Produto",
      item_brand: "IHTP",
      price: money(line?.preco ?? line?.PrecoUnitario ?? 0),
      quantity: num(quantidade) || 1,
    };
  });
}

/** Evento e-commerce GA4 (add_to_cart, view_cart, begin_checkout, …). */
export function gaEcommerce(name, items, value, currency = "EUR", extra = {}) {
  gaEvent(name, { currency: currency || "EUR", value: money(value), items, ...extra });
}
